import SelectLocation from "../Personal/SelectLocation";
import PersonalCategories from "./PersonalCategories";
import PersonalProfile from "./PersonalProfile";
import PublicationPreview from "./PublicationPreview";
import PublicationPreviewAvatar from "./PublicationPreviewAvatar";
import PublicationSliderGallery from "./PublicationSliderGallery";
import PersonalFilters from "./PersonalFilters";
import PublicationSuccess from "./PublicationSuccess";
import PublicationEdit from "./PublicationEdit";

const createPersonal = [

    {
        title: 'publication_personal_location',
        progress: { title: 'publication_personal_progress_region', step: 2 },
        component: SelectLocation, valid: true, required: true,
    },

    {
        title: 'publication_personal_choose_category',
        progress: { title: 'publication_personal_progress_category', step: 3 },
        component: PersonalCategories, valid: true, required: true,
    },

    {
        title: 'publication_personal_enter_pet_data',
        progress: { title: 'publication_personal_progress_enter_data', step: 4 },
        component: PersonalProfile, valid: true, required: false,
    },

    {
        title: 'publication_personal_enter_ad_text',
        progress: { title: 'publication_personal_progress_ad_text', step: 5 },
        component: PublicationPreview, valid: true, required: true,
    },

    {
        title: 'publication_personal_upload_profile_photo',
        progress: { title: 'publication_personal_progress_profile_photo', step: 6 },
        component: PublicationPreviewAvatar, valid: true, required: true,
    },

    {
        title: 'publication_personal_upload_gallery_photos',
        progress: { title: 'publication_personal_progress_ad_photos', step: 7 },
        component: PublicationSliderGallery, valid: true, required: true,
    },

    {
        title: 'publication_personal_additional',
        progress: { title: 'publication_personal_progress_additional', step: 8 },
        subtitle: 'publication_personal_additional_optional',
        component: PersonalFilters, valid: true, required: false,
    },

    {
        title: 'publication_personal_check_entered_data',
        progress: { title: 'publication_personal_progress_check_data', step: 9 },
        component: PublicationEdit, valid: true, required: true,
    },

    {
        progress: { title: 'publication_personal_progress_thanks', step: 10 },
        component: PublicationSuccess, valid: true, required: true,
    },



];

export default createPersonal;
